import { render, staticRenderFns } from "./SidebarBreakdownPopup.vue?vue&type=template&id=371cb053&scoped=true"
import script from "./SidebarBreakdownPopup.vue?vue&type=script&lang=ts"
export * from "./SidebarBreakdownPopup.vue?vue&type=script&lang=ts"
import style0 from "./SidebarBreakdownPopup.vue?vue&type=style&index=0&id=371cb053&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371cb053",
  null
  
)

export default component.exports